import { graphql } from "~/gql";

export const UPDATE_NOTIFICATION_RULE = graphql(/* GraphQL */ `
  mutation UpdateNotificationRule($data: UpdateNotificationRulesInput!) {
    updateNotificationRule(data: $data) {
      ...NotificationRuleParts
    }
  }
`);
